// src/LandingPage.js
import React from 'react';
import { Container, Typography, Button, Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function LandingPage() {
  return (
    <Container maxWidth="md" sx={{ mt: 5 }}>
      <Typography variant="h3" align="center" gutterBottom>
        Advise: Your AI Mental Health Partner
      </Typography>
      <Typography variant="h6" align="center" paragraph>
        Welcome to <strong>Advise</strong>, the AI-powered mental health app tailored to meet the unique challenges of college students, especially those involved in fraternities and sororities. Whether you're navigating academic pressure, social stress, or personal challenges, Advise is here to provide personalized, confidential support whenever you need it.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Why Choose Advise?
      </Typography>
      <List>
        {[
          '24/7 AI Therapist: Get instant advice and emotional support, day or night.',
          'Tailored for College Life: Customized specifically for the college experience, with a deep understanding of fraternity and sorority life.',
          'Anonymity Guaranteed: Your conversations are private and secure, giving you the peace of mind to talk freely.',
          'Self-Care Tools: Access a wide range of exercises, mindfulness practices, and coping strategies to maintain your mental well-being.',
          'Always Evolving: Our AI continuously learns to provide better and more effective advice based on your interactions.',
        ].map((text) => (
          <ListItem key={text}>
            <ListItemIcon>
              <CheckCircleIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>

      <Box textAlign="center" my={4}>
        <Typography variant="h6" paragraph>
          Take control of your mental health journey with a tool designed for you. Download <strong>Advise</strong> today and have a supportive, non-judgmental AI therapist in your pocket!
        </Typography>
        <Button variant="contained" color="primary" size="large" href="#">
          Download Now
        </Button>
      </Box>

      <Box textAlign="center">
        <Button variant="text" href="/privacy-policy">
          Privacy Policy
        </Button>
      </Box>
    </Container>
  );
}

export default LandingPage;
